module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5x32C"))).then(() => parcelRequire('d0iPb'));